import React, { type FC } from 'react';

import {
    DefaultTheme,
    UIThemeProvider as LibUIThemeProvider,
} from '@selina-finance/ui';
import {
    MutationCache,
    QueryCache,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './app/i18n/i18n';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { captureError, initSentry } from './shared/helpers/sentry';
import { initAnalytics } from './utils/analytics';

const UIThemeProvider: FC<any> = (props) =>
    React.createElement(LibUIThemeProvider as any, props);

initSentry();

const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error, query) => {
            captureError(error, {
                tags: {
                    source: 'react-query',
                    type: 'query',
                },
                extra: {
                    queryKey: query.queryKey,
                },
            });
        },
    }),
    mutationCache: new MutationCache({
        onError: (error, _variables, _context, mutation) => {
            captureError(error, {
                tags: {
                    source: 'react-query',
                    type: 'mutation',
                },
                extra: {
                    mutationKey: mutation.options.mutationKey,
                },
            });
        },
    }),
});

initAnalytics();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

const renderApp = () => {
    root.render(
        <UIThemeProvider theme={DefaultTheme}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter basename='/personal-loan'>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </UIThemeProvider>,
    );
};

if ('fonts' in document) {
    document.fonts.ready.then(renderApp);
} else {
    renderApp();
}

reportWebVitals();
